import { deepEquals } from './deep-equals';

/**
 * This is written here instead of in the useOdinMemo hook for simplicity’s sake.
 * @param {ReadonlyArray<unknown>} oldArray - The original item array.
 * @param {ReadonlyArray<unknown>} newArray - The new array of items to check against the original.
 * @param {Array<string>} ignoreProperties - A string array of properties to ignore when running the deep equal's check.
 * @returns {boolean} True if the arrays are different.
 */
export function arraysAreDifferent(
  oldArray: ReadonlyArray<unknown>,
  newArray: ReadonlyArray<unknown>,
  ignoreProperties: Array<string> = []
): boolean {
  for (let i = oldArray.length; i-- !== 0; ) {
    if (oldArray[i] !== newArray[i] && !deepEquals(oldArray[i], newArray[i], ignoreProperties)) {
      return true;
    }
  }

  return false;
}
